import { render, staticRenderFns } from "./Fluxograma.vue?vue&type=template&id=6eee8892&"
import script from "./Fluxograma.vue?vue&type=script&lang=js&"
export * from "./Fluxograma.vue?vue&type=script&lang=js&"
import style0 from "./Fluxograma.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
